<script setup lang="ts">
import type {ImageType, LinkType} from "~/graphql/misc";

const props = defineProps<{
  image: ImageType,
  download?: LinkType,
  features: string[],
  size: number,
  width: number,
  length: number,
  popup: string,
  designOptions: string[]
}>();

const scrollToContact = (event: Event) => {
  event.preventDefault();
  const contactSection = document.getElementById('contact-form-section');
  if (contactSection) {
    const offset = 150;
    const elementPosition = contactSection.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};
</script>

<template>
  <div class="row h-100 d-flex align-items-stretch home-design-section">
    <div class="col-12 col-md-5 position-relative">
      <div class="z-1 w-100 h-100 bg-white rounded-4 d-flex align-items-center justify-content-center">
        <nuxt-img
            :alt="props.image?.node?.title"
            :srcset="props.image?.node?.srcSet"
            :src="props.image?.node?.mediaItemUrl"
            :width="props.image?.node?.mediaDetails?.width"
            :height="props.image?.node?.mediaDetails?.height"
            class="w-100 rounded-4 object-fit-contain img-floor-plan"/>
      </div>
      <div class="position-absolute top-0 end-0 p-3">
        <button class="me-3 p-0 bg-transparent border-0 btn-show-floor-plan" data-bs-toggle="modal" data-bs-target="#floor-plan-modal">
          <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 43.75 43.75">
            <g id="Group_319" data-name="Group 319" transform="translate(-1518.576 -2228.861)">
              <circle id="Ellipse_9" data-name="Ellipse 9" cx="21.336" cy="21.336" r="21.336" transform="translate(1519.115 2229.4)" fill="none" stroke="#353535" stroke-width="1.078"/>
              <g id="Group_318" data-name="Group 318">
                <path id="Path_999" data-name="Path 999" d="M1539.655,2258.654v-7.181h-6.521v-1.591h6.521v-7.065h1.591v7.065h6.522v1.591h-6.522v7.181Z" fill="#353535"/>
              </g>
            </g>
          </svg>
        </button>
      </div>
      <FloorPlan :floorPlanImg="props?.image?.node"/>
    </div>
    <div class="col-12 col-md-7 d-flex flex-column justify-content-between px-md-4">
      <div class="w-100 ps-md-4 ps-0 mt-md-0 mt-4">
        <div class="area-info row mb-3 mb-md-5">
          <div class="col d-flex align-items-center">
            <h5 class="mb-2 fw-bold">{{ props.size }} m²</h5>
          </div>
          <div class="col d-flex align-items-center justify-content-md-end gap-3">
            <h5 class="fw-bold">Width:</h5><h5>{{ new Intl.NumberFormat().format(props.width) }}m</h5>
            <h5 class="fw-bold">Length:</h5><h5>{{ new Intl.NumberFormat().format(props.length) }}m</h5>
          </div>
        </div>
        <div class="row mb-3 mb-md-0">
          <div class="col">
            <h4 class="fw-bold">Home Features</h4>
            <hr class="feature-divider mb-4"/>
            <div 
                v-for="(feature, index) in props.features" 
                :key="index"
                class="feature-item text-primary ms-4"
            >
                <h5 class="mb-0"><span class="mx-3 details-separator">&bullet;</span>{{ feature }}</h5>
            </div>
            <div 
                v-for="(optionItem, index) in props.designOptions" 
                :key="index"
                class="design-options text-primary ms-4"
            >
                <h5 class="mb-0"><span class="mx-3 details-separator">&bullet;</span>{{ optionItem }}</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="ps-md-4 ps-0 d-grid gap-3 d-md-flex justify-content-md-start">
        <a href="#contact-form-section"
           class="text-center btn btn-primary text-uppercase rounded-pill px-5 shadow-none"
           @click="scrollToContact">Enquire</a>
        <a v-if="props.download"
           :title="props.download.title"
           :target="props.download.target"
           :href="props.download.url"
           class="text-center btn btn-outline-primary text-uppercase rounded-pill px-4 shadow-none">Download Plan</a>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.img-floor-plan {
  height: 500px;
}
</style>
